// 横屏游戏
export const pcHorizontalGameCodes = [
  'JDB_0_14027'
]
